import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../Api/api";

const LandingPageContext = createContext();

export const LandingPageProvider = ({ children }) => {
  const [landingData, setLandingData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLandingPageContent = async () => {
      try {
        const response = await api.get("/public/api/landing-page-content");
        setLandingData(response.data.data);
      } catch (error) {
        console.log("Failed to fetch landing page content", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLandingPageContent();
  }, []);

  return (
    <LandingPageContext.Provider
      value={{
        landingData,
        loading,
      }}
    >
      {children}
    </LandingPageContext.Provider>
  );
};

export const useLandingPage = () => useContext(LandingPageContext);